import { defineInterface } from '@nzyme/ioc/Interface.js';
export const ChatLoader = defineInterface({
    name: 'ChatLoader',
});
//# sourceMappingURL=ChatLoader.js.map